<template>
  <div class="materialPurchase">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">药品采购</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select v-model="fishBaseId" filterable placeholder="请选择" size="small" @change="baseChange">
              <el-option v-for="(item, index) in baseList" :key="index" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>在&nbsp;&nbsp;</span>
            <el-date-picker size="small" v-model="start" type="date" :clearable="false" placeholder="开始日期" @change="changeTime(0)" value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding: 0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding: 0 1px">
            <el-date-picker size="small" v-model="end" type="date" :clearable="false" placeholder="结束日期" @change="changeTime(1)" value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <!-- <div class="select-container-box">
            <span>在&nbsp;&nbsp;</span>
            <el-select v-model="type" filterable size="small">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入关键字" v-model="keyword" prefix-icon="el-icon-search" size="small" type="text" :maxlength="20"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" class="search-input" clearable>
            </el-input>
          </div> -->
          <el-popover class="pop-condition" placement="bottom" width="580" v-model="popoverVisible" trigger="click">
            <div class="condition">
              <section class="mask">
                <div class="popover-container-box">
                  <span class="popover-label">单据编号：</span>
                  <el-input placeholder="请输入" v-model="orderNumber" :maxlength="num" size="small" class="search-input" clearable>
                  </el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">塘口：</span>
                  <el-input placeholder="请输入" v-model="pondName" :maxlength="num" size="small" class="search-input" clearable>
                  </el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">渔药：</span>
                  <el-input placeholder="请输入" v-model="medicine" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">疫苗：</span>
                  <el-input placeholder="请输入" v-model="vaccine" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">供应商：</span>
                  <el-input placeholder="请输入" v-model="dealerName" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">经办人：</span>
                  <el-input placeholder="请输入" v-model="leader" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">制单人：</span>
                  <el-input placeholder="请输入" v-model="userName" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
              </section>
              <div class="comfirm">
                <span @click="popoverVisible = false">关闭</span>
                <span @click="goSearch(1)">查询</span>
              </div>
            </div>
            <div class="more" slot="reference">更多条件</div>
          </el-popover>
          <audit-status :audit-status.sync="auditStatus" />
          <div class="select-container-box" v-if="(canEditAll = true)">
            <el-button size="small" type="info" plain @click="goSearch(1)" class="query">查询</el-button>
            <el-button size="small" type="info" plain @click="goAdd" class="add" v-if="edit == true">增加</el-button>
            <ExportExcelBtn apiUrl="/api/MaterialPurchase/Export" :queryParamsObj="queryParams" fileName="药品采购.xls" />
            <!-- <el-button size="small"  type="info" plain @click="batchAuditOrder" class="query" style="width: auto;">批量审核</el-button> -->
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table :data="materialPurchaseList.list" style="width: 100%" @row-dblclick="dataBackFillGoods" :summary-method="getSummaries" show-summary size="medium"
          :default-sort="{ prop: 'date', order: 'descending' }">
          <i slot="empty" style="font-style: normal">该时间段暂无数据</i>
          <el-table-column type="expand">
            <template slot-scope="props">
              <c-descriptions>
                <c-descriptions-row v-for="(item, index) in props.row.details" :key="index" grid-template-columns="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr">
                  <c-descriptions-item label="物资名称">{{
                    item.name
                  }}</c-descriptions-item>
                  <c-descriptions-item label="物资大类">{{
                    item.category
                  }}</c-descriptions-item>
                  <c-descriptions-item label="物资类型">{{
                    item.type
                  }}</c-descriptions-item>
                  <c-descriptions-item label="单位">{{
                    item.unit
                  }}</c-descriptions-item>
                  <c-descriptions-item label="数量">{{
                    item.quantity
                  }}</c-descriptions-item>
                  <c-descriptions-item label="单价">{{
                    item.unitPriceTax
                  }}</c-descriptions-item>
                  <c-descriptions-item label="金额">{{
                    item.amountTotal
                  }}</c-descriptions-item>
                  <c-descriptions-item label="调整金额">{{
                    item.amountAdjust
                  }}</c-descriptions-item>
                  <c-descriptions-item label="结算金额">{{
                    item.settleAmount
                  }}</c-descriptions-item>
                </c-descriptions-row>
              </c-descriptions>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="日期" width="70" show-overflow-tooltip :formatter="formatter" align="center">
          </el-table-column>
          <el-table-column prop="orderNumber" align="center" label="单据编号" width="130">
          </el-table-column>
          <el-table-column prop="fishBaseName" align="center" label="基地">
          </el-table-column>
          <el-table-column prop="fishPondName" align="center" label="塘口">
          </el-table-column>
          <el-table-column prop="totalQuantity" label="总数量" width="110" show-overflow-tooltip align="center" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="totalAmount" align="center" width="110" label="总金额" show-overflow-tooltip :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="totalSettleAmount" label="结算金额" width="110" show-overflow-tooltip align="center" :formatter="$formatCellNumberKeepTwo">
          </el-table-column>
          <el-table-column prop="dealerName" label="供应商" align="center" width="150" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="leader" label="经办人" show-overflow-tooltip width="120" align="center"></el-table-column>
          <el-table-column prop="userName" label="制单人" show-overflow-tooltip width="120" align="center">
          </el-table-column>
          <el-table-column label="操作栏" align="center">
            <template slot-scope="scope">
              <!-- <span class="content-edit" v-if="scope.row.auditStatus === 0" @click="handleAuditStatus(scope.row)">审核</span> -->
              <span @click="baseSettingEdit(scope.$index, scope.row)" class="content-edit" style="margin-left: 20px">{{ edit ? "编辑" : "查看" }}</span>
              <span @click="baseSettingDelete(scope.$index, scope.row)" class="content-del" v-if="edit">删除</span>
              <!-- <span v-if="scope.row.auditStatus !== 0">已审核</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>

<script>
import PageChange from "../../common/PageChange";
import AuditStatus from "@/components/AuditStatus";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";
import ExportExcelBtn from "../../common/ExportExcelBtn";
export default {
  name: "drugProcurement",
  mixins: [mixins],
  components: {
    PageChange,
    AuditStatus,
    ExportExcelBtn,
  },
  data () {
    return {
      num: 20,
      popoverVisible: false,
      start: "", //开始时间
      end: "", //结束时间
      pickerTimeOptions: {
        // 限制日期
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      fishBaseId: "", //基地
      baseList: [], //基地列表
      type: "",
      typeList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "pondName",
          label: "塘口",
        },
        {
          label: "渔药",
          value: 10002,
        },
        {
          label: "疫苗",
          value: 10003,
        },
      ],
      pondName: "",
      medicine: "",
      vaccine: "",
      keyword: "", //查找
      orderNumber: "", //单据编号
      dealerName: "", //供应商
      leader: "", //经办人
      userName: "", //制单人
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.goSearch, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
      auditStatus: "", //审核状态 0-待审核 1-已审核
    };
  },
  //默认时间
  created () {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
  methods: {
    ...mapActions(modules.materialPurchase, [
      "getMaterialPurchaseData",
      "getMaterialPurchaseDataV2",
      "delMaterialPurchaseDetail",
      "delMaterialPurchase",
    ]),
    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.auditOrder, [
      "auditMaterialOrder",
      "auditMaterialOrderByMouth",
    ]), // 审核
    //记住基地
    baseChange (e) {
      storage.set("base", e);
    },
    // 字段筛选过滤
    filterHandler (value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //存储选中时间
    changeTime (type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },
    // 格式化指定列时间
    formatter (row) {
      if (!row.date) {
        return false;
      }
      return this.$timeformatDay(row.date);
    },
    //合计
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if ([5, 6, 7].indexOf(index) == -1) {
          sums[index] = "--";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums.map((item) => {
        if (typeof item === "number" && !isNaN(item)) {
          item = item.toFixed(2);
        }
        return item;
      });
    },
    //双击进入编辑页面
    dataBackFillGoods (row, event) {
      // if(row.auditStatus !== 0) return
      this.$router.push({
        name: "addDrugProcurement",
        query: {
          id: row.orderId,
        },
      });
    },
    //查询
    async goSearch (pageNum) {
      // 设置sessionStorage
      sessionStorage.setItem("MaterialPurchaseKeyword", this.keyword);

      let obj = this.queryParams;
      obj.pageIndex = this.pageInfo.pageNumber = pageNum || 1;

      this.getMaterialPurchaseDataV2(obj)
        .then((rsp) => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch((err) => {
          console.dir(err);
        });

      this.popoverVisible = false;
    },
    //同步
    goExport () { },
    // 添加
    goAdd () {
      this.$router.push({
        name: "addDrugProcurement",
        query: {
        },
      });
    },
    //编辑
    baseSettingEdit (index, row) {
      this.$router.push({
        name: "addDrugProcurement",
        query: {
          id: row.orderId,
        },
      });
    },

    //删除
    baseSettingDelete (index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.delMaterialPurchase(row.orderId);
          this.goSearch(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error",
          });
          // this.$message.error(err.response.data);
        });
    },
    isPermiss () {
    },
    // 审核
    async handleAuditStatus (row) {
      const confirmRes = await this.$confirm("确认审核通过该单据?").catch(
        (err) => err
      );
      if (confirmRes !== "confirm") return;
      await this.auditMaterialOrder({
        id: row.orderId,
        auditStatus: 1,
      }).catch((err) => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error",
        });
      });
      this.goSearch();
    },
    // 批量审核
    async batchAuditOrder () {
      const confirmRes = await this.$confirm("", "批量操作", {
        confirmButtonText: "批量审核",
        cancelButtonText: "批量驳回",
        center: true,
        distinguishCancelAndClose: true,
      }).catch((err) => err);
      if (confirmRes === "close") return;
      const auditStatus = confirmRes === "confirm" ? 1 : 0;
      const params = {
        auditStatus, // 审核状态 0-待审核 1-已审核 2-审核不通过
        fishBaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList),
        startDate: this.start,
        endDate: this.end,
        CategoryList: [10002, 10003],
        Medicine: this.medicine || undefined,
        Vaccine: this.vaccine || undefined,
        PondName: this.pondName, //!this.type || this.type === "pondName" ? this.keyword : "",
        orderNumber: this.orderNumber,
        dealerName: this.dealerName,
        leader: this.leader,
        userName: this.userName,
        pageIndex: 1, // 当前页数(从1开始)
        pageSize: 10000, // 分页条数
      };
      // if (this.type !== "") {
      //   params[this.type] = this.keyword;
      // }
      await this.auditMaterialOrderByMouth(params).catch((err) => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error",
        });
      });
      this.goSearch();
    },
  },
  computed: {
    // 获取 是否为企联网
    whetherQlw () {
      return this.curCompany.isQlwVersion;
    },
    ...mapState(modules.materialPurchase, ["materialPurchaseList"]),
    //需要筛选的字段
    getFilterTypeList () {
      const res = new Map();
      let fiterList = this.materialPurchaseList.list
        .map((m) => ({
          value: m.category,
          text: m.category,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    //需要筛选的字段
    getFilterTypesList () {
      const res = new Map();
      let fiterList = this.materialPurchaseList.list
        .map((m) => ({
          value: m.type,
          text: m.type,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    queryParams () {
      let obj = {
        pageIndex: this.pageInfo.pageNumber || 1,
        pageSize: this.pageInfo.pageSize,
        fishBaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList),
        startDate: this.start,
        endDate: this.end,
        AuditStatus: this.auditStatus, //审核状态 0-待审核 1-已审核
        CategoryList: [10002, 10003],
        Medicine: this.medicine || undefined,
        Vaccine: this.vaccine || undefined,
        PondName: this.pondName, //!this.type || this.type === "pondName" ? this.keyword : "",
        orderNumber: this.orderNumber,
        dealerName: this.dealerName,
        leader: this.leader,
        userName: this.userName,
      };

      return obj;
    },
  },
  watch: {
    // 监听isQlwVersion
    whetherQlw (val) {
      this.isPermiss();
    },
  },
  async mounted () {
    this.isPermiss();
    this.baseList = await this.getAllBaseList({ forQueryAll: true });
    // sessionstorage记住查找关键字
    this.judgeSession("MaterialPurchaseKeyword");
    this.keyword = this.word;
    this.fishBaseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    this.goSearch();
  },
  //缓存路由组件重新被激活 事件，重新查询列表数据
  activated () {
    this.goSearch(this.pageInfo.pageNumber);
  },
};
</script>

<style lang="stylus" scoped>
.pop-condition {
  .more {
    margin-left: 20px;
    padding: 0 20px;
    line-height: 32px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 230, 230, 1));
    border: 1px solid rgba(198, 198, 198, 1);
    border-radius: 4px;
    color: #333333;
    cursor: pointer;
  }
}

.el-popover {
  width: 580px !important;

  .unit {
    display: inline-block;
    line-height: 32px;
    width: 180px;
    text-align: left;
  }

  .condition {
    color: #333;
    font-size: 16px;

    .more {
      height: 32px;
      padding: 0 12px;
      border-radius: 5px;
      line-height: 32px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 230, 230, 1));
      border: 1px solid rgba(198, 198, 198, 1);
    }
  }

  .mask {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 5px 20px 15px 20px;
    z-index: 20;
    font-size: 16px;
    color: #666;
    background: #fff;

    .more {
      margin-left: 20px;
    }

    .popover-container-box {
      width: 260px;
      margin-top: 15px;
      display: flex;

      .popover-label {
        width: 130px;
      }
    }

    .el-input__inner {
      height: 36px;
      width: 180px;
    }

    >div {
      &:nth-child(2n) {
        text-align: right;
        padding-left: 0;

        >span {
          width: 80px;
          text-align: right;
        }
      }
    }
  }

  .comfirm {
    text-align: center;
    font-size: 16px;

    >span {
      display: inline-block;
      width: 100px;
      margin: 15px 0;
      border: 1px solid #BBBBBB;
      border-radius: 4px;
      line-height: 36px;
      background: #fff;
      cursor: pointer;

      &:nth-child(2) {
        margin-left: 20px;
        border: 1px solid #3389FF;
        color: #fff;
        background: #3389FF;
      }
    }
  }
}
</style>
